export default __webpack_public_path__ + "static/media/04_Go-for-a-hikoi.af91df01.jpg";